import {Blocker, BlockerFunction, useBlocker, useInRouterContext} from 'react-router-dom';

const UNBLOCKED_STATE: Blocker = {
  state: 'unblocked',
  reset: undefined,
  proceed: undefined,
  location: undefined,
};

/**
 * Blocks router navigation while blockerFunction returns true. Multiple mounted blockers are
 * consulted in registration order (patched react-router behavior, see
 * patches/react-router@7.18.2.patch) — the first one that blocks wins and only that instance's
 * blocker.state becomes 'blocked'.
 */
export function useBlockNavigating(blockerFunction: BlockerFunction) {
  const isWithinRouterContext = useInRouterContext();

  const getUnblockedState = () => UNBLOCKED_STATE;
  const useAppropriateBlocker = isWithinRouterContext ? useBlocker : getUnblockedState;
  const blocker = useAppropriateBlocker(blockerFunction);

  return {blocker};
}
